module.exports = __webpack_public_path__ + "static/media/3.32885d81.png";